<script setup>
import { ref, onMounted, reactive, computed, watch } from 'vue'

const props = defineProps({
  defaultOpen: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

let isOpen = ref(props.defaultOpen);

function toggleOpen() {
  // Don't toggle if disabled
  if (props.disabled) return;
  
  if (isOpen.value) {
    isOpen.value = false;
  } else {
    isOpen.value = true;
  }
}

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

// Expose methods to parent components
defineExpose({
  open,
  close,
  toggleOpen
});

</script>

<template>
  <div class="CollapseDiv">
    <button class="CollapseBtn" @click="toggleOpen" :class="{IsOpen: isOpen}">
      <slot name="title">Default title</slot>
    </button>
    <div v-if="isOpen" class="Content">
      <slot name="content">Default body</slot>
    </div>
  </div>
</template>

<style scoped>
.CollapseDiv {
  max-width: 1000px;
}

.CollapseBtn {
  background-color: white;
  width: 100%;
  border: 1px solid var(--pc-light);
  border-radius: 4px;
  padding: 12px 16px;
  text-align: left;
  font-size: var(--f-m);
  transition: all 0.2s ease;
  color: var(--pc-dark);
  position: relative;
}

.CollapseBtn:hover {
  background-color: var(--pc-lightest);
}

.CollapseBtn.IsOpen {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: transparent;
  background-color: var(--pc-lightest);
}

.Content {
  padding: var(--space-m);
  background-color: white;
  border: 1px solid var(--pc-light);
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
